// consider separating out each scrolling table and each view into separate components?

import React, { Component } from 'react';
import '../styles/App.css';
import ActivityWrapper from '../components/ActivityWrapper';
import GenderAverages from '../components/GenderAverages';
import WorkoutStats from '../components/WorkoutStats';
import Confetti from 'react-dom-confetti';

import '../styles/MainScreen.css';

let workoutSwitcher;

// confetti settings
const config = {
  angle: 45,
  spread: 120,
  startVelocity: 60,
  elementCount: 40,
  decay: 0.9
};

class MainScreen extends Component {

  constructor(props) {
    super(props);
    console.log(this.props);
    
    this.state = {
      workoutObj: this.props.recentWorkout.length > 0 ? this.props.recentWorkout[0] : {},
      workoutIdx: 0,
      amountOfPrs: this.props.activityArray.length
    }
  }

  componentDidMount() {
  }

  componentDidUpdate() {
    if(this.props.activityArray.length !== this.state.amountOfPrs) {
      this.setState({
        amountOfPrs: this.props.activityArray.length,
        confetti: true
      }, () => {
        this.setState({confetti: false})
      })
    }
  }

  componentWillUnmount() {
    
  }

  render() {
    return(
      <div className="inner-wrap absolute flex pa4 w-100 h-100">
        <div className="activity light-blue-border w-100">
          <ActivityWrapper 
            {...this.props}
          />
        <Confetti active={ this.state.confetti } config={ config } />
        </div>
      </div>
    )
  }
}

export default MainScreen;


// WEBPACK FOOTER //
// ./src/containers/MainScreen.js